/* eslint-disable @typescript-eslint/no-explicit-any */
import { createStore } from "solid-js/store";

import { BetByGameId } from "@/enum/game";
import { sysConfigStore } from "@/stores/sysConfigStore";
import { GameHelper } from "@/types/gameHelper";
import { GameNode, GetGameListRsp } from "@/types/swagger/front";

interface gclass_game_listType {
  [key: string]: [];
}

// 创建一个共享的 GameHelper 实例
const gameHelper = new GameHelper();

export const [gameStore, setGameStore] = createStore({
  gameListData: {} as GetGameListRsp,
  gclass_game_list: {} as gclass_game_listType,
  curGameId: 0,
  // 存储是否未结束游戏时访问的游戏的参数，进入游戏后直接调用
  curGameUrl: "",
  curGameBody: "",
  curBetByRes: {},
  gameCollectList: [] as GameNode[],
  betbyParams: null as any,
  gameLoaded: false,
  continueGameList: [] as GameNode[],
  ext: {} as any,
});

// export const initGameStore = (gameListData: GetGameListRsp) => {
//   setGameStore("gameListData", reconcile(gameListData));
//
//   const gclass_game_list: any = {};
//
//   gameListData.list.forEach((item) => {
//     if (gclass_game_list[item.gclass]) {
//       gclass_game_list[item.gclass].push(item);
//     } else {
//       gclass_game_list[item.gclass] = [item];
//     }
//     // 初始化时也把游戏数据存入 GameHelper
//     gameHelper.insertGameDataByGid(item);
//   });
//   setGameStore("gclass_game_list", gclass_game_list);
// };

// export const checkGameStoreInit = () => {
//   return gameHelper.getGameDataByGid(gameStore.curGameId) !== null;
// };

export const getGameDataByGid = (gid: number) => {
  return gameHelper.getGameDataByGid(gid);
};

export const insertGameDataByGid = (game: GameNode) => {
  if (!game.game_id) {
    console.error("[insertGameDataByGid] game_id is null");
    return;
  }
  gameHelper.insertGameDataByGid(game);
};

// 设置当前游戏ID
export const setCurGameId = (
  gid: number,
  gUrl?: string,
  gBody?: string,
  betby_rsp?: any,
  ext?: any,
) => {
  setGameStore("curGameId", gid);
  if (gUrl || gUrl === "") setGameStore("curGameUrl", gUrl || "");
  if (gBody || gBody === "") setGameStore("curGameBody", gBody || "");
  if (betby_rsp || betby_rsp === "")
    setGameStore("curBetByRes", betby_rsp || "");
  setGameStore("ext", ext || {});
};

export const getProviderByGplat = (config, gplat: number) => {
  return (
    config?.game_plat_list?.find((item) => {
      return item.PlatId === gplat;
    }) || null
  );
};

// export const handleGameCollect = (game: GameNode) => {
//   setGameStore("gameCollectList", (prev) => [...prev, game]);
// };

export const updateGameLoaded = (loaded: boolean) => {
  setGameStore("gameLoaded", loaded);
};
